import { LucideIcon } from "@ews-admin/global-design-system";
import React from "react";

interface QuickActionCardProps {
  title: string;
  description?: string;
  icon: LucideIcon;
  onClick: () => void;
  className?: string;
  variant?: "default" | "primary" | "secondary";
}

export const QuickActionCard: React.FC<QuickActionCardProps> = ({
  title,
  description,
  icon: Icon,
  onClick,
  className = "",
  variant = "default",
}) => {
  const getVariantClasses = () => {
    switch (variant) {
      case "primary":
        return "bg-ews-primary text-white hover:bg-ews-primary-hover";
      case "secondary":
        return "bg-ews-secondary text-white hover:bg-ews-secondary-hover";
      default:
        return "bg-white text-neutral-700 hover:bg-neutral-50 border border-neutral-200 hover:border-neutral-300";
    }
  };

  return (
    <button
      onClick={onClick}
      className={`flex flex-col items-center p-4 space-y-3 w-full text-center rounded-xl transition-shadow duration-200 shadow-soft hover:shadow-lg ${getVariantClasses()} ${className}`}
    >
      <div
        className={`w-12 h-12 rounded-lg flex items-center justify-center hover-scale ${variant === "default"
            ? "bg-ews-primary"
            : "bg-white/20"
          }`}
      >
        <Icon
          className={`w-6 h-6 ${variant === "default" ? "text-white" : "text-white"
            }`}
        />
      </div>

      <div>
        <h3
          className={`text-base font-semibold mb-1 ${variant === "default" ? "text-neutral-900" : "text-white"
            }`}
        >
          {title}
        </h3>
        {description && (
          <p
            className={`text-xs ${variant === "default" ? "text-neutral" : "text-white/80"
              }`}
          >
            {description}
          </p>
        )}
      </div>
    </button>
  );
};
